import { Controller } from "@hotwired/stimulus"

// Toggles the new-nav sidebar drawer (and its dimming scrim) on small screens.
// Open state is a `data-open` attribute the CSS transitions off of (slide +
// fade); above md the drawer utilities don't apply, so toggling is inert there.
export default class extends Controller {
  static targets = ["panel", "scrim", "toggle"]

  toggle() {
    this.setOpen(!this.panelTarget.hasAttribute("data-open"))
  }

  close() {
    this.setOpen(false)
  }

  setOpen(open) {
    this.panelTarget.toggleAttribute("data-open", open)
    this.scrimTarget.toggleAttribute("data-open", open)
    this.toggleTarget.setAttribute("aria-expanded", open)
  }
}
